import { Component, OnInit, Input } from '@angular/core';
import { DateTime } from 'luxon';
import { KeyDatesService } from '../../../../shared/services/keydates.service';
import { CorrespondenceTimelineService } from '../../../../shared/services/correspondence-timeline.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from 'src/app/shared/services/modal.service';
import { YesNoPopupComponent } from 'src/app/shared/components/yes-no-popup/yes-no-popup.component';
import { OkPopupComponent } from 'src/app/shared/components/ok-popup/ok-popup.component';

@Component({
  selector: 'app-add-key-date',
  templateUrl: './add-key-date.component.html',
  styleUrls: ['./add-key-date.component.scss']
})
export class AddKeyDateComponent implements OnInit {

  @Input() caseId?: number;
  @Input() keyDateTypeId?: number;
  @Input() keyDateId?: number;
  @Input()  keyDateName?: string;

  private notes?: string;

  @Input() keyDateValue?: any;

  public keyDateTime: string = "";

  private date: any;

  public loading = false;

  saveButtonDisabled: boolean = false;

  constructor(
  public activeModal: NgbActiveModal,
  private keyDatesService: KeyDatesService,
  public modalService: ModalService,
  private correspondenceTimelineService: CorrespondenceTimelineService) {


  }

  ngOnInit(): void {
    
    if(this.keyDateValue == null){
      this.date = new Date();
      this.keyDateValue = DateTime.local().toFormat('yyyy-MM-dd');
    }
    else
      this.keyDateValue = DateTime.fromISO(this.keyDateValue).toFormat('yyyy-MM-dd');
  }

  cancel(){
    this.activeModal.dismiss();
  }

  validateTime(){
    var isValid = /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/.test(this.keyDateTime);

    if(!isValid)
      this.saveButtonDisabled = true;
    else
      this.saveButtonDisabled = false;
  }

  saveKeyDate(){
    var keyDateData: any;

    keyDateData = { caseId: this.caseId, keyDateType: this.keyDateTypeId, value: this.keyDateValue };

    this.loading = true;

      this.keyDatesService.addKeyDate(keyDateData).subscribe(response => {

        this.correspondenceTimelineService.refreshCaseTimeline.next();


      if(this.keyDateTypeId == 19 ) // Documents Returned from Consultant - need to popup and ask about bank statement
      {

         const modalRef = this.modalService.openWithOptions(YesNoPopupComponent, {size: 'lg'});
                 
          modalRef.componentInstance.messageHeader = 'Has the banking statement been received?';
      
          modalRef.result.then(
            (result) => {
              if(result)
              {

              this.keyDatesService.bankStatementReceived(this.caseId).subscribe(response => {
                this.correspondenceTimelineService.refreshCaseTimeline.next();
                this.keyDatesService.refreshKeyDates.next();
                this.activeModal.close(true);

            });
            }
            else 
                this.activeModal.close(true);
          },
            () => {} // dismissed - do nothing
          );

      }
      else if(this.keyDateTypeId == 13 ) // Offer Received
      {
          const modalRef = this.modalService.openWithOptions(YesNoPopupComponent, {size: 'lg'});
                 
          modalRef.componentInstance.messageHeader = 'Has CTP/Broker Fee Agreement been Received?';
      
          modalRef.result.then(
            (result) => {
              if(!result)
              {
                this.keyDatesService.feeAgreementNotReceived(this.caseId).subscribe(response => {
                  this.activeModal.close(true);

                });
              }
              else 
                this.activeModal.close(true);
          },
            () => {} // dismissed - do nothing
          );
      }
      else
      {
        this.activeModal.close(true);

        if(this.keyDateTypeId == 45 ){ /* Key Date - ‘Initial Documents been sent to client’  */

          const modalRef = this.modalService.openWithOptions(OkPopupComponent, {size: 'lg'});
                 
          modalRef.componentInstance.messageHeader = 'Mortgage Details';
          modalRef.componentInstance.popupText1 = 'Please check the mortgage details have been updated on the case';
        }

      }

      this.loading = false;

      }, (error : any) => {

        var errorMessage = "Adding Key Date Failed";
        if(error.error !== null && error.error.message !== undefined)
        {
          errorMessage = error.error.message;
        }

      });
  }

}
